var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twitter"},[_c('a',{staticClass:"twitter-timeline",attrs:{"href":"https://twitter.com/hashtag/pokethon","data-widget-id":"975169638509133824","data-width":"35vw","data-height":"60vh","data-chrome":"nofooter,noscrollbar","data-aria-polite":"rude"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2945d24f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Twitter.vue
// module id = KmDw
// module chunks = 1